import {uploadImage} from "./upload-image";
import {shutterStockRetrieveContributor} from "../constants/api";
import {FAIL, UPLOAD_IMAGE} from "../constants/action-types";

export const uploadShutterstockImage = (url, query, item) => (dispatch) => {
  shutterStockRetrieveContributor(item.contributor.id)
    .then((contributor) =>
      dispatch(
        uploadImage(
          url,
          {
            isShutterstockImage: true
          },
          {
            id: item.id,
            searchRequest: query,
            contributor: contributor[`display_name`]
          }
        )
      )
    )
    .catch(() =>
      dispatch({
        type: UPLOAD_IMAGE + FAIL
      })
    );
};
